import React from "react";

import { Link, useMatch, useResolvedPath } from "react-router-dom";

const CustomLink = ({ children, to, ...props }) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });
  return (
    <li
      onClick={() => {if(props && props.setDrawer) props.setDrawer(false)}}
      className={match ? "drawer__link-list-item active" : "drawer__link-list-item"}
    >
      {props && props.icon && <span className="drawer__link-icon">{props.icon}</span>}
      <Link
        to={to}
        //   {...props}
      >
        {children}
      </Link>
    </li>
  );
};

export default CustomLink;
